import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ISiteRequestDetails } from '../../feature/site-rediness-matrix/models/request';

export const SiteRequestsAdapter = createEntityAdapter<ISiteRequestDetails>({ selectId: (item: ISiteRequestDetails) => item.id });

export interface SiteRequestRequestsState extends EntityState<ISiteRequestDetails> {
  isLoaded?: boolean;
  message?: string | null;
  selectedItemId?: number;
}

export const intialSiteRequestsState: SiteRequestRequestsState = SiteRequestsAdapter.getInitialState({
  isLoaded: false
});


const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = SiteRequestsAdapter.getSelectors();

export const selectSiteRequestsEntities = selectEntities;

export const selectAllSiteRequestsEntities = selectAll;

export const getSiteRequestsIsLoaded = (state: SiteRequestRequestsState) => state.isLoaded;
export const getSiteRequestsMessage = (state: SiteRequestRequestsState) => state.message;
export const getSiteRequestsSelectedId = (state: SiteRequestRequestsState) => state.selectedItemId;


